var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-dialog" }, [
    _c("div", { staticClass: "modal-content" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c("h4", { staticClass: "modal-title" }, [_vm._v("Payment log")]),
        _vm._v(" "),
        _c("button", {
          staticClass: "btn-close",
          attrs: { type: "button", "aria-label": "Close" },
          on: {
            click: function ($event) {
              return _setup.emit("hide-modal")
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _setup.items
          ? _c(
              "div",
              { staticClass: "list-group" },
              _vm._l(_setup.items, function (item) {
                return _c(
                  "div",
                  { key: item.id, staticClass: "list-group-item" },
                  [
                    _c("div", [
                      _vm._v(
                        "\n                        £" +
                          _vm._s(item.amount) +
                          " - " +
                          _vm._s(item.label) +
                          "\n                        "
                      ),
                      item.paymentNote
                        ? _c("span", [_vm._v(" - " + _vm._s(item.paymentNote))])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "date font-monospace" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_setup.getDate(item.date)) +
                          "\n                    "
                      ),
                    ]),
                  ]
                )
              }),
              0
            )
          : _c("div", { staticClass: "text-center p-3" }, [
              _vm._v("\n                Loading logs...\n            "),
            ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }